var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrustpilotRatings1HalfstarRgb = function SvgTrustpilotRatings1HalfstarRgb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 18,
    viewBox: "0 0 97 18"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Trustpilot_ratings_1halfstar-RGB_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.598 0H19v18H.598Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Trustpilot_ratings_1halfstar-RGB_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78 0h17.895v18H78Zm0 0"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Trustpilot_ratings_1halfstar-RGB_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1e1e1e",
      fillOpacity: 1
    },
    d: "M18.465 0H.598v18h17.867Zm0 0"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#dcdce6",
      fillOpacity: 1
    },
    d: "M37.824 0h-17.87v18h17.87Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1e1e1e",
      fillOpacity: 1
    },
    d: "M28.887 0h-8.934v18h8.934Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#dcdce6",
      fillOpacity: 1
    },
    d: "M57.18 0H39.313v18H57.18ZM76.54 0H58.667v18h17.871Zm0 0"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Trustpilot_ratings_1halfstar-RGB_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#dcdce6",
      fillOpacity: 1
    },
    d: "M95.895 0H78.027v18h17.868Zm0 0"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "m9.531 12.133 2.719-.695 1.133 3.523Zm6.254-4.559H11L9.531 3.04 8.06 7.574H3.277l3.871 2.813-1.468 4.539 3.87-2.813 2.384-1.726ZM28.887 12.133l2.718-.695 1.137 3.523Zm6.254-4.559h-4.782L28.887 3.04l-1.469 4.535h-4.785l3.875 2.813-1.473 4.539 3.871-2.813 2.383-1.726ZM48.246 12.133l2.719-.695 1.133 3.523ZM54.5 7.574h-4.785L48.246 3.04l-1.473 4.535h-4.78l3.87 2.813-1.468 4.539 3.87-2.813 2.383-1.726ZM67.602 12.133l2.718-.695 1.137 3.523Zm6.253-4.559h-4.78L67.601 3.04l-1.47 4.535h-4.784l3.875 2.813-1.473 4.539 3.871-2.813 2.383-1.726ZM86.96 12.133l2.72-.695 1.132 3.523Zm6.255-4.559H88.43L86.96 3.04l-1.472 4.535h-4.781l3.871 2.813-1.469 4.539 3.871-2.813 2.383-1.726Zm0 0"
  }));
};
export default SvgTrustpilotRatings1HalfstarRgb;